import regex from '../regex'

/**
 * Custom validator for valid house number + addition
 * @param  {String} value | input value
 * @param {Object} options
 * @returns {String|null} returns null which validates as true in validate.js or an error string
 */
const houseNumberAndAddition = function (value, options) {
  const validHouseAndAddition =
    value &&
    regex.houseNumberRegex.test(value) &&
    value.length <= 10 &&
    !regex.houseNumberAdditionRegex.test(value)
  if (!validHouseAndAddition) {
    return options.message
  }
  return null
}
export default houseNumberAndAddition
